import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ["fallback"];

  fallbackTargetConnected(element) {
    element.remove();
  }

  submit(event) {
    if (event?.type === "keydown") {
      if (event.target.tagName === "TEXTAREA") return;

      event.preventDefault();
    }

    if (this.queued) return;

    this.queued = true;

    Promise.resolve().then(() => {
      this.queued = false;
      this.element.requestSubmit();
    });
  }
}
